/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.3",
    versionName: "0.2.0-nightly.2025.8.3",
    versionChannel: "nightly",
    buildDate: "2025-08-03T00:10:04.632Z",
    commitHash: "966dfef805b2530c4b0fabade33eb6d3629134cd",
};
